<template>
  <div class="outer-container">
    <div class="ucontainer whole">
      <div class="grid">
        <div class="gradient">
          <h1 class="manrope">
            What has our partners <br />
            got to say about Upskill?
          </h1>
        </div>
        <div id="center">
          <tiny-slider
            :mouse-drag="true"
            :loop="true"
            items="1"
            navPosition="bottom"
            gutter="20"
            controlsPosition="bottom"
            speed="2000"
            :autoplay="true"
            :arrow-keys="true"
            :navAsThumbnails="true"
            :responsive="{}"
          >
            <div class="slide">
              <div class="flex1">
                <div class="right">
                  <h2>
                    {{ items[0].title }}
                  </h2>
                  <h3>
                    {{ items[0].subtitle }}
                  </h3>
                </div>
              </div>

              <p>
                {{ items[0].body }}
              </p>
            </div>
            <div class="slide">
              <div class="flex1">
                <div class="right">
                  <h2>
                    {{ items[1].title }}
                  </h2>
                  <h3>
                    {{ items[1].subtitle }}
                  </h3>
                </div>
              </div>

              <p>
                {{ items[1].body }}
              </p>
            </div>
            <div class="slide">
              <div class="flex1">
                <div class="right">
                  <h2>
                    {{ items[2].title }}
                  </h2>
                  <h3>
                    {{ items[2].subtitle }}
                  </h3>
                </div>
              </div>

              <p>
                {{ items[2].body }}
              </p>
            </div>
          </tiny-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import UTestimonialSlider from '../core/UTestimonialSlider.vue';
import VueTinySlider from 'vue-tiny-slider'
export default {
  data() {
    return {
      items: [
        {
          title: 'Bongo',
          body:
            ' It is really difficult to hire people specially with a specific skill set. Demand for Data Science is not going to go away in Bangladesh and its growing. Upskill has been founded to help people to actually get people trained and get the right job.',
          image: require('../../assets/saquif.jpg'),
        },
        {
          title: 'Inteligent Machines',
          body:
            'Learning is a continuous journey. Be aware, Stay Open and Keep Learning. Upskill is giving people the platform to learn and follow their dreams. ',
          image: require('../../assets/saquif.jpg'),
        },
        {
          title: 'Bongo',
          body:
            'These days data is massive. So it is important to answer the “What” & “Why” question in terms of visualization with actionable insight.',
          image: require('../../assets/saquif.jpg'),
        },
      ],
    }
  },

  components: {
    'tiny-slider': VueTinySlider,
  },
}
</script>

<style scoped>
.outer-container {
  padding-top: 100px;
}

.whole {
  padding: 0 25px;
  padding-bottom: 100px;
}
#center {
  background-color: #fff;
  max-width: 650px;
  border-radius: 0 10px 10px 0;
}
.slide {
  padding: 0px;
}
.flex1 {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 50px;
}

.right h2 {
  font-family: 'Manrope';
  font-weight: 700;
  font-size: 24px;
  letter-spacing: -1.2px;
  color: #000000;
  text-transform: capitalize;
  opacity: 1;
}
.right h3 {
  font-family: 'Manrope';

  font-weight: 400;
  font-size: 18px;

  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
p {
  margin: 10px 50px;
  padding-top: 50px;
  text-align: left;
  font-family: 'Manrope';

  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0px;
  color: #728391;
  opacity: 1;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1300px;
  margin: 0 auto;
}
.gradient {
  background: #184dbd;
  border-radius: 10px 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gradient h1 {
  font-family: 'Manrope';
  font-size: 36px;
  font-weight: 700;
  text-align: left;

  letter-spacing: -0.8px;
  color: #ffffff;
  opacity: 1;
}

@media only screen and (max-width: 600px) {
  .gradient h1 {
    font-family: 'Manrope';
    font-size: 32px;
    font-weight: 700;
    text-align: center;

    letter-spacing: -0.8px;
    color: #ffffff;
    opacity: 1;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr;
  }
  .whole {
    padding: 0 0px;
    padding-bottom: 0px;
  }

  .flex1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-left: 0px;
    margin-right: 80px;
  }
  .right {
    padding-left: 0;
    margin-top: 15px;
    margin-left: 50px;
    display: flex;
    flex-direction: column;
  }
  #center {
    margin: 0 auto;
    background-color: #fff;
    max-width: 350px;
    width: 100%;
  }
  .tns-controls button {
    display: none !important;
  }
  .gradient {
    min-height: 350px;
  }
}
</style>
